<template>
  <div class="relative w-full text-left">
    <div class="relative">
      <TextInput
        type="text"
        :class="[
          'w-full pr-8',
          disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        ]"
        readonly
        :disabled="disabled"
        :value="inputValue"
        :placeholder="defaultText"
        :variant="isError? 'error' : 'default'"
        @click="!disabled && toggleDropdown()"
      />
      <ChevronDownFilled
        :className="`absolute right-3 top-1/2 transform -translate-y-1/2 h-3 w-3 pointer-events-none ${disabled ? 'text-gray-400' : 'text-gray-500'}`"
      />
    </div>

    <!-- Dropdown Menu -->
    <div v-if="isOpen && !disabled" class="absolute right-0 z-10 w-full mt-1 bg-white border rounded-md shadow-sm ring-1 ring-black ring-opacity-5">
      <div class="p-1">
        <label
          v-for="option in statusOptions"
          :key="option.value"
          class="flex items-center p-2 m-0 cursor-pointer hover:bg-gray-100"
          @click="selectOption(option)"
        >
          <input
            type="radio"
            :value="option.value"
            :checked="selectedContentStatus === option.value"
            @change="handleRadioChange(option)"
            class="w-4 h-4 text-blue-600 form-radio"
          />
          <span class="ml-2 text-gray-700">{{ option.text }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
// import { cva } from 'class-variance-authority';
import ChevronDownFilled from '@/components/icons/ChevronDownFilled';
import TextInput from '@/components/ui/TextInput';

export default {
  name: 'SelectRadio',
  components: {
    ChevronDownFilled,
    TextInput
  },
  props: {
    value: [String, Number, Boolean],
    defaultText: {
      type: String,
      default: 'Select Content Type'
    },
    options: Array,
    isError: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      selectedContentStatus: this.value || '',
      statusOptions: this.options || [],
      inputValue: ''
    };
  },
  computed: {
    selectedOptionText() {
      const selectedOption = this.statusOptions.find(option => option.value === this.selectedContentStatus);
      return selectedOption ? selectedOption.text : '';
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.updateInputValue();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      if (!this.disabled) {
        this.isOpen = !this.isOpen;
      }
    },
    selectOption(option) {
      this.selectedContentStatus = option.value;
      this.inputValue = option.text;
      this.isOpen = false;
      this.$emit('input', this.selectedContentStatus);
    },
    handleRadioChange(option) {
      this.selectOption(option);
    },
    handleClickOutside(event) {
      if (this.isOpen && !this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
    updateInputValue() {
      this.inputValue = this.selectedOptionText;
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.selectedContentStatus = newValue;
        this.updateInputValue();
      },
      immediate: true
    },
    options: {
      handler(newOptions) {
        this.statusOptions = newOptions || [];
        this.updateInputValue();
      },
      immediate: true
    }
  }
}
</script>
